module.exports = __webpack_public_path__ + "static/button-hudlvoice-do-5afb8ec2809b4936dfce26bf9ace0518.png";